enum PaintType {
  Standard = 'standard',
  Metallic = 'metallic',
  Special = 'special',
  Pastel = 'pastel',
  Unilack = 'unilack',
}

export default PaintType;

